import type { Theme } from '@emotion/react';

import { DEFAULT_THEME } from '../default/index';
import { createThemeGlobalStyles } from '../default/styles';
import { TYPOGRAPHY } from '../default/typography';
import { DARK_COLORS, DARK_CONTRAST_COLORS, DARK_HUES } from './colors';

export const DARK_THEME: Theme = {
  ...DEFAULT_THEME,
  hues: DARK_HUES,
  contrastColors: DARK_CONTRAST_COLORS,
  colors: DARK_COLORS,
  typography: TYPOGRAPHY,
  globalStylesComponent: createThemeGlobalStyles(DARK_COLORS),
};
